<div>
    <h2>Nuestros Productos</h2>
    <div class="tab-class text-center">
        <app-catalogs-selector [catalogs]="catalogs" (getCategory)="getCategory($event)" [isDetail]="false">
        </app-catalogs-selector>
        <div class="tab-content">
            <div id="tab-1" class="tab-pane fade show p-0 active">
                <div class="row g-4">
                    <div class="col-lg-12">
                        @if(products.length) {
                        <div class="row g-4">
                            @for(product of products; track product) {
                            <div class="col-md-6 col-lg-4 col-xl-3">
                                <app-product-card [product]="product"></app-product-card>
                            </div>
                            }
                        </div>
                        } @else {
                        <div>No se encontraron productos</div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>